import { LocalConfig } from 'src/common/utils';

const AFFILIATE_ID = 168;

const isAffiliate = () => Number(LocalConfig.get('projectId')) === AFFILIATE_ID;

export const pushPageViewEvent = () => {
  if (!isAffiliate()) {
    return;
  }
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'page_view',
    page_location: window.location.href,
    page_path: window.location.pathname,
    page_title: window.document.title,
  });
};

export const pushRegistrationFillingStartEvent = () => {
  if (!isAffiliate()) {
    return;
  }
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'registration_filling_start',
  });
};

export const pushLogoutEvent = (userId, affiliateId) => {
  if (!isAffiliate()) {
    return;
  }
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'logout',
    user: {
      affiliate_id: affiliateId,
      user_id: String(userId),
    },
  });
  window.dataLayer.push({
    user: null,
  });
};
